<template>
  <div :id="subSection.id"
       class="pdf-preview-sub-section-category-header content-row">
    <div class="item-no left flat"></div>
    <div class="sub-sub-section-unit flat"></div>
    <div class="category-header-wrapper"
         v-html="categoryHeaderTable(itemCategories)">
    </div>
    <div class="item-no right flat"></div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: 'SubSectionCategoryHeader',
  props: {
    subSection: Object,
    itemCategories: Array,
  },
  setup(props) {
    const categoryHeaderTable = function (categories) {
      if (!categories || categories.length === 0) {
        return '';
      }

      let columns = categories.map((cat) => {
        return JSON.parse(cat.definition);
      });

      const max_row = _.max(columns.map((col) => col.length))
      const max_col = categories.length;

      let result = columns.map((col) => {
        return col.map((value) => {
          return {'rowspan': 1, 'colspan': 1, 'value': value}
        })
      });

      _.range(max_row).forEach((row) => {
        let current_category = null;
        let current_col = 0;
        let current_row = row;

        _.range(max_col).forEach((col) => {
          let value = columns[col][row];
          if (value !== undefined) {
            if (!current_category) {
              current_category = value
              current_col = col
              current_row = row
            } else {
              if (current_category !== value) {
                current_category = value
                current_col = col
                current_row = row
              } else {
                result[current_col][current_row]['colspan'] += 1
                result[col][row] = false;
              }
            }
          }
        })
      })

      _.range(max_col).forEach((col) => {
        let total_row_span = 0;
        result[col].forEach(() => {
          total_row_span += 1;
        })
        let col_length = result[col].length;
        if (col_length < max_row) {
          _.range(max_row - col_length).forEach((i) => {
            if (result[col][i % col_length] !== false) {
              result[col][i % col_length]['rowspan'] += 1
            }
          })
        }
      })

      let transposed = _.range(max_row).map(() => {
        return [];
      });
      result.forEach((cells) => {
        cells.forEach((cell, row) => {
          if (cell !== false) {
            transposed[row].push(cell)
          }
        })
      })

      let table = `<table style="width: ${39 * max_col + 1}px">`;
      transposed.forEach((row) => {
        table += '<tr>';
        row.forEach((cell) => {
          if (cell !== false) {
            let colspan = cell["colspan"];
            table += `<td colspan="${colspan}" rowspan="${cell["rowspan"]}" style="width: ${38 * colspan + 1}px;">${cell["value"]}</td>`
          }
        })

        table += '</tr>';
      })

      return table;
    }

    return {
      categoryHeaderTable,
    }
  }
}
</script>
